// extracted by mini-css-extract-plugin
module.exports = {"baggage__name":"baggage__name-1NySq","baggage__size":"baggage__size-2CuNe","baggageIcon__wrapper":"baggageIcon__wrapper-2Kfd-","baggageIcon__size":"baggageIcon__size-3-Ksj"};